import React from "react";
import AdminSectionShell from "../components/AdminSectionShell";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";
import ViewAtendimento from "../views/ViewAtendimento";

const Atendimento: React.FC = () => {
  const { isLoading, isValid } = usePermissao("ADM");

  if (isLoading) {
    return <p>Verificando permissão...</p>;
  }

  if (!isValid) {
    return null;
  }

  return (
    <AdminSectionShell backTo="/inicio">
      <ViewAtendimento />
    </AdminSectionShell>
  );
};

export default Atendimento;
